import React from 'react';
import PropTypes from 'prop-types';

import Select from 'bento-ordering/base/components/Select';

class DatePicker extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    value: PropTypes.string,
    onDateChange: PropTypes.func,
    options: PropTypes.array,
    label: PropTypes.string,
    dataTestId: PropTypes.string
  };

  handleOnDateChange = e => {
    this.props.onDateChange(e.target.value);
  };

  render() {
    const { id, value, options, label, dataTestId } = this.props;

    return (
      <Select
        variant="filled"
        autoWidth={false}
        value={value}
        onChange={this.handleOnDateChange}
        id={id}
        name={id}
        options={options}
        label={label}
        dataTestId={dataTestId}
      />
    );
  }
}

export default DatePicker;
